import { Chart } from 'chart.js';

Chart.defaults.font.family = 'Montserrat, sans-serif';
Chart.defaults.font.size = 14;
Chart.defaults.scale.ticks.color = '#000000';
Chart.defaults.color = '#000000';
Chart.defaults.borderColor = '#d1d1d1';

export default function () {
  const { t } = useI18n();

  Chart.register({
    id: 'empty',
    afterDraw: function (chart, _easing) {
      if (!chart.data.datasets?.some(ds => ds.data.length)) {
        // No data is present
        const ctx = chart.ctx;
        const width = chart.width;
        const height = chart.height * 0.95;
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = "16px normal 'Montserrat, sans-serif'";
        ctx.fillStyle = '#333333';
        const emptyLabel =
          chart.options.plugins?.empty?.label || t('common.noItemsFound');
        ctx.fillText(emptyLabel, width / 2, height / 2);
        ctx.restore();
      }
    }
  });

  Chart.register({
    id: 'doughnut-center-text',
    beforeDraw: function (chart) {
      // Get options from the center object in options
      const centerConfig = chart.config.options.elements?.center;
      const innerRadius = (chart._metasets[chart._metasets.length - 1]
        ?.data?.[0]?.innerRadius || 200) as number;

      if (!centerConfig || !innerRadius) {
        return;
      }

      // Get ctx from string
      const ctx = chart.ctx;

      const fontStyle =
        centerConfig.fontStyle || "bold 'Montserrat, sans-serif'";
      const text = centerConfig.text;
      const color = centerConfig.color || '#333333';
      const maxFontSize = centerConfig.maxFontSize || 75;
      const sidePadding = centerConfig.sidePadding || 20;
      const sidePaddingCalculated = (sidePadding / 100) * (innerRadius * 2);
      // Start with a base font of 30px
      ctx.font = '12px ' + fontStyle;

      // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
      const stringWidth = ctx.measureText(text).width;
      const elementWidth = innerRadius * 2 - sidePaddingCalculated;

      // Find out how much the font can grow in width.
      const widthRatio = elementWidth / stringWidth;
      const newFontSize = Math.floor(12 * widthRatio);
      const elementHeight = innerRadius * 2;

      // Pick a new font size so it will not be larger than the height of label.
      let fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
      let minFontSize = centerConfig.minFontSize;
      const lineHeight = centerConfig.lineHeight || 25;
      let wrapText = false;

      if (minFontSize === undefined) {
        minFontSize = 12;
      }

      if (minFontSize && fontSizeToUse < minFontSize) {
        fontSizeToUse = minFontSize;
        wrapText = true;
      }

      // Set font settings to draw it correctly.
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      let centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
      ctx.font = fontSizeToUse + 'px ' + fontStyle;
      ctx.fillStyle = color;

      if (!wrapText) {
        ctx.fillText(text, centerX, centerY);
        return;
      }

      const words = text.split(' ');
      let line = '';
      const lines = [];

      // Break words up into multiple lines if necessary
      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + ' ';
        const metrics = ctx.measureText(testLine);
        const testWidth = metrics.width;
        if (testWidth > elementWidth && n > 0) {
          lines.push(line);
          line = words[n] + ' ';
        } else {
          line = testLine;
        }
      }

      // Move the center up depending on line height and number of lines
      centerY -= (lines.length / 2) * lineHeight;

      for (let n = 0; n < lines.length; n++) {
        ctx.fillText(lines[n], centerX, centerY);
        centerY += lineHeight;
      }
      // Draw text in center
      ctx.fillText(line, centerX, centerY);
      ctx.restore();
    }
  });

  return Chart;
}
